var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAsideBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.66999 14.795C8.45905 15.0057 8.17311 15.124 7.87499 15.124C7.57686 15.124 7.29093 15.0057 7.07999 14.795L0.704987 8.42001C0.494311 8.20908 0.375977 7.92314 0.375977 7.62501C0.375977 7.32689 0.494311 7.04095 0.704987 6.83001L7.07999 0.455015C7.29338 0.256402 7.57546 0.148247 7.86693 0.153281C8.15841 0.158317 8.43658 0.27615 8.64299 0.482015C8.84885 0.688419 8.96669 0.966594 8.97172 1.25807C8.97676 1.54955 8.8686 1.83162 8.66999 2.04501L4.21499 6.50001L15.375 6.50001C15.6734 6.50001 15.9595 6.61854 16.1705 6.82952C16.3815 7.0405 16.5 7.32665 16.5 7.62501C16.5 7.92338 16.3815 8.20953 16.1705 8.42051C15.9595 8.63149 15.6734 8.75001 15.375 8.75001H4.21499L8.66999 13.205C8.88066 13.416 8.999 13.7019 8.999 14C8.999 14.2981 8.88066 14.5841 8.66999 14.795Z",
    fill: "#787878"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAsideBack);
export default __webpack_public_path__ + "static/media/aside-back.44334ee508bc525e99853183d63e1a86.svg";
export { ForwardRef as ReactComponent };